import { useEffect } from 'react';

const BASE_TITLE = 'Hoopla POS';

export function useTitleBadge(activeCount: number) {
  useEffect(() => {
    const previous = document.title;
    document.title = activeCount > 0 ? `(${activeCount}) ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = previous;
    };
  }, [activeCount]);
}
